// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cvJU","left":"styles_left__1aiWS"};